/* @flow */

import React from 'react';

type Props = {
  fill?: string,
  rotate?: number,
  scale?: number,
};

export default ({fill = 'currentColor', rotate = 0, scale = 1}: Props) => (
  <div style={{transform: `rotate(${rotate}deg) scale(${scale})`}}>
    <svg viewBox="0 0 40 40">
      <polygon fill={fill} points="25.0007575 20.0007575 40 5.00265103 35 3.55271368e-15 20 15 5 3.55271368e-15 -1.42108547e-14 5.00265103 14.9992425 20.0007575 0 35 5 40 20 25.0011362 35 40 40 35 25.0007575 20.0007575" />
    </svg>
  </div>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/Cross.js